import React from 'react';

import { Button, ControlledModal, Loading, Tippy } from '@/components';
import { InformationIcon } from '@/components/icons';
import { PlayerStats } from './PlayerStats';

type AutoCalculateRewardButtonProps = {
  disabled?: boolean;
  onClick: () => void;
  rewardDetails: React.ComponentProps<typeof PlayerStats>['rewardDetails'];
  fetching: boolean;
};

const AutoCalculateRewardButton = ({
  disabled,
  onClick,
  rewardDetails,
  fetching,
}: AutoCalculateRewardButtonProps) => {
  return (
    <div className="flex gap-1">
      <Button
        className="flex-1"
        variant="tertiary"
        onClick={onClick}
        disabled={fetching || disabled}
        type="button"
      >
        {fetching ? (
          <Loading />
        ) : (
          <Tippy content="Click to auto calculate reward">
            <span>Auto Calculate Reward ✨</span>
          </Tippy>
        )}
      </Button>
      <ControlledModal content={<PlayerStats rewardDetails={rewardDetails} />}>
        <Button type="button">
          <Tippy content="Click for more info">
            <span>
              <InformationIcon className="bg-grey-400 text-gray-500" />
            </span>
          </Tippy>
        </Button>
      </ControlledModal>
    </div>
  );
};

export default AutoCalculateRewardButton;
